import { AppRoute, AppRouteParams } from './types';

export function defineRoute<TParams extends AppRouteParams>(
  pathname: string,
): AppRoute<TParams> {
  return Object.freeze({
    pathname,

    url(params: TParams): string {
      let url = pathname;
      const urlSearchParams = new URLSearchParams();

      Object.entries(params).forEach(([key, val]) => {
        if (url.includes(`[${key}]`)) {
          url = url.replace(`[${key}]`, val);
        } else {
          urlSearchParams.append(key, val);
        }
      });

      const query = urlSearchParams.toString();
      return query ? `${url}?${query}` : url;
    },

    urlObject(params: TParams) {
      return { pathname, params };
    },
  }) as AppRoute<TParams>;
}
